import { ProjectTanium } from '../models/ProjectTanium';

export class ProjectTaniumMapper {
  mapGQLModel(data: any) {
    return new ProjectTanium(data.computerGroup, data.status, data.todoCount, data.endpointsCount, data.completedAt);
  }
}
